import { Fragment, ReactNode, useEffect, useState } from 'react';
import { IntlProvider as ReactIntlProvider } from 'react-intl';
import { BUS_TOPIC_GLOBALLANGUAGE, getWidgetBus } from '../services/helpers';
import en from '../locales/en.json';
import fr from '../locales/fr.json';

type SupportedLocale = 'en' | 'fr';
export const locales: { [key in SupportedLocale]: { [key: string]: string } } = {
  en,
  fr,
};

export const IntlProvider = ({ children }: { children: ReactNode }) => {
  const [locale, setLocale] = useState<SupportedLocale>('en');

  // Use the SGWT Widgets bus to be aware of the modification of the language,
  // which is triggered by the <sgwt-account-center> widget.
  useEffect(() => {
    const bus = getWidgetBus();

    const urlParams = new URLSearchParams(window.location.search);
    const languageParam = urlParams.get('language');

    if (window.self !== window.top && languageParam && Object.keys(locales).includes(languageParam.toLowerCase())) {
      setLocale(languageParam.toLowerCase() as SupportedLocale);
    } else if (bus) {
      const languageSubscription = bus.subscribe<string>(BUS_TOPIC_GLOBALLANGUAGE, (lang: string | undefined) => {
        if (lang && Object.keys(locales).includes(lang.toLowerCase())) {
          setLocale(lang.toLowerCase() as SupportedLocale);
        }
      });
      return () => {
        bus.unsubscribe(languageSubscription);
      };
    }
  }, []);

  return (
    <ReactIntlProvider locale={locale} messages={locales[locale]} textComponent={Fragment}>
      {children}
    </ReactIntlProvider>
  );
};
